// ©2024 Austin App House. All rights reserved.
import React from 'react';

const HistoryCard = ({ historyInfo }) => (
  <div
    className="history_section"
  >
    <ul className="history_list">
      <li>
        <span>Create</span>
        <span>{new Date(historyInfo.createdAt).toLocaleString('en-US')}</span>
        </li>
        <li>
        <span>Operation type</span>
        <span>{historyInfo.type}</span>
        </li>
        <li>
        <span>Work order status</span>
        <span>{historyInfo.work_order_status.replace(/^\w/, c => c.toUpperCase())}</span>
        </li>
        <li>
        <span>Description</span>
        <span>{historyInfo.description}</span>
        </li>
      </ul>
    </div>
  
);

export default HistoryCard;
